import Swiper from 'swiper/bundle';
import { onReady } from '../lib/on-ready.js';

function initFeatureCardCarousels() {
    document.querySelectorAll('.swiper-feature-card').forEach((container) => {
        if (container.swiper) {
            return;
        }

        new Swiper(container, {
            slidesPerView: 1,
            spaceBetween: 20,
            loop: false,
            navigation: {
                nextEl: container.querySelector('.swiper-button-next'),
                prevEl: container.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                1240: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
                980: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                640: {
                    slidesPerView: 1,
                    grabCursor: true,
                    centeredSlides: true,
                },
            },
            a11y: {
                enabled: true,
                slideLabelMessage: 'Slide {{index}} of {{slidesLength}}',
            },
        });
    });
}

onReady(initFeatureCardCarousels);
